var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { v4 as uuidv4 } from 'uuid';
import { getCurrentScene, setCurves, setPressingMode } from "../../../redux/actions/canvas/canvas";
import store from "../../../redux/store";
import { addCommand } from '../../history/HistoryService';
export var start = function (event) {
    setPressingMode(true);
    var scene = getCurrentScene();
    var _a = store.getState().canvas, cameraOffset = _a.cameraOffset, scale = _a.scale, pencilAttrs = _a.pencilAttrs;
    if (scene) {
        var curves = scene.curves;
        var pos = event.target.getStage().getPointerPosition();
        var adjustedPos = {
            x: (pos.x - cameraOffset.x) / scale,
            y: (pos.y - cameraOffset.y) / scale
        };
        var id = uuidv4();
        setCurves(__spreadArray(__spreadArray([], __read(curves), false), [{
                id: id,
                tool: 'curve',
                points: [adjustedPos.x, adjustedPos.y],
                attr: __assign({}, pencilAttrs),
                time: new Date()
            }], false));
        // Добавляем команду в историю для возможности отката
        addCommand('ADD_CURVE', { id: id });
    }
};
export var move = function (event) {
    var _a = store.getState().canvas, isPressed = _a.isPressed, cameraOffset = _a.cameraOffset, scale = _a.scale;
    var scene = getCurrentScene();
    if (!isPressed)
        return;
    if (scene) {
        var curves = scene.curves;
        var stage = event.target.getStage();
        var point = stage.getPointerPosition();
        // Adjust the point position considering the current camera offset and scale
        var adjustedPoint = {
            x: (point.x - cameraOffset.x) / scale,
            y: (point.y - cameraOffset.y) / scale
        };
        var lastCurve = curves[curves.length - 1];
        // Сглаживание: добавляем точку только если она достаточно далеко от предыдущей
        var points = lastCurve.points;
        var lastX = points[points.length - 2];
        var lastY = points[points.length - 1];
        var minDistance = 2 / scale; // минимальная дистанция с учетом масштаба
        var distance = Math.sqrt(Math.pow(adjustedPoint.x - lastX, 2) +
            Math.pow(adjustedPoint.y - lastY, 2));
        // Добавляем точку только если она достаточно далеко
        if (distance > minDistance) {
            lastCurve.points = lastCurve.points.concat([adjustedPoint.x, adjustedPoint.y]);
            // replace last
            curves.splice(curves.length - 1, 1, lastCurve);
            setCurves(curves.concat());
        }
    }
};
export var finish = function (event) {
    setPressingMode(false);
};
